export const masterPass = {
    productionClientApi : "https://static.masterpass.com/dyn/js/switch/integration/MasterPass.client.js",
    sandboxClientApi    : "https://sandbox.static.masterpass.com/dyn/js/switch/integration/MasterPass.client.js",
};

export const mobilePay = {
    productionClient: "https://public.mobilepay.dk/p2o/router/address/router.aspx",
};

export const epayZero = {
    testClient : "http://localhost:1337", // TODO: get it hosted
    walletApi  : "https://wallet-v1.api-eu.bambora.com",
};



// WEBPACK FOOTER //
// ./src/endpoints.ts